import { Theme } from '@mui/material/styles';

export type CardColors = "primary" | "secondary" | "error" | "success" | "warning" | "info" | "notice" ;

const transition = {
    transition: "all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
};

const container = {
    paddingRight: "15px",
    paddingLeft: "15px",
    marginRight: "auto",
    marginLeft: "auto"
};


const card = {
    display: "inline-block",
    position: "relative",
    width: "100%",
    margin: "25px 0",
    boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.14)",
    borderRadius: "3px",
    color: "rgba(0, 0, 0, 0.87)",
    background: "#fff"
};

const noticeCardHeader = (theme: Theme) => ({
    color: theme.palette.common.black,
    backgroundColor: theme.genie.palette.notice.dark,
    boxShadow: theme.genie.palette.notice.boxShadow,
    "& a": {
        color: theme.genie.palette.notice.contrastText
    },
    "& a:hover": {
        color: theme.genie.palette.notice.contrastText
    }

});

const warningCardHeader = (theme: Theme) => ({
    color: theme.genie.palette.warning.contrastText,
    backgroundColor: theme.genie.palette.warning.dark,
    boxShadow: theme.genie.palette.warning.boxShadow,
    "& a": {
        color: theme.genie.palette.warning.contrastText
    },
    "& a:hover": {
        color: theme.genie.palette.warning.light
    }

});

const successCardHeader = (theme: Theme) => ({
    color: theme.genie.palette.success.contrastText,
    backgroundColor: theme.genie.palette.success.dark,
    boxShadow: theme.genie.palette.success.boxShadow
});

const infoCardHeader = (theme: Theme) => ({
    color: theme.genie.palette.info.contrastText,
    backgroundColor: theme.genie.palette.info.dark,
    boxShadow: theme.genie.palette.info.boxShadow
});


const errorCardHeader = (theme: Theme) => ({
    color: theme.palette.error.contrastText,
    background: theme.palette.error.dark,
    boxShadow: theme.genie.boxShadow.error ? "none" : theme.genie.boxShadow.error
});

const primaryCardHeader = (theme: Theme) => ({
    color: theme.palette.primary.contrastText,
    background: theme.palette.primary.main,
    boxShadow: theme.genie.boxShadow.primary ? "none" : theme.genie.boxShadow.primary
});

const secondaryCardHeader = (theme: Theme) => ({
    color: theme.palette.secondary.contrastText,
    background: theme.palette.secondary.dark,
    boxShadow: theme.genie.boxShadow.secondary ? "none" : theme.genie.boxShadow.secondary
});


const cardActions = {
    margin: "0 20px 10px",
    paddingTop: "10px",
    borderTop: "1px solid #eeeeee",
    height: "auto",
};

const cardHeader = {
    margin: "-20px 15px 0",
    borderRadius: "3px",
    padding: "15px"
};

const cardColorTheme = (theme: Theme) => {

    const infoHeader = infoCardHeader(theme);
    const errorHeader = errorCardHeader(theme);
    const successHeader = successCardHeader(theme);
    const warningHeader = warningCardHeader(theme);
    const primaryHeader = primaryCardHeader(theme);
    const secondaryHeader = secondaryCardHeader(theme);

    return {
        headerRoot: {
            padding: 0,
        },

        headerContent: {
            padding: theme.spacing(2),
        },

        headerContentDense: {
            padding: theme.spacing(1),
        },

        infoHeaderContent: {
            ...infoHeader
        },
        successHeaderContent: {
            ...successHeader
        },
        warningHeaderContent: {
            ...warningHeader
        },
        errorHeaderContent: {
            ...errorHeader
        },
        primaryHeaderContent: {
            ...primaryCardHeader(theme)
        },
        secondaryHeaderContent: {
            ...secondaryCardHeader(theme)
        },

        infoHeaderTitle: {
            color: infoHeader.color
        },
        successHeaderTitle: {
            color: successHeader.color
        },
        warningHeaderTitle: {
            color: warningHeader.color
        },
        errorHeaderTitle: {
            color: errorHeader.color
        },
        primaryHeaderTitle: {
            color: primaryHeader.color
        },
        secondaryHeaderTitle: {
            color: secondaryHeader.color
        }
    }
}

export {
    transition,
    container,

    noticeCardHeader,
    warningCardHeader,
    successCardHeader,
    errorCardHeader,
    infoCardHeader,
    primaryCardHeader,
    secondaryCardHeader,

    card,
    cardActions,
    cardHeader,

    cardColorTheme
};

